import React from 'react';

export default function Tooltip({ showTooltip }) {
  if (!showTooltip?.visible) return null;
  return (
    <div
      className="fixed bg-gray-800 text-white text-sm px-3 py-1.5 rounded-lg shadow-lg z-50 animate-fade-in"
      style={{
        left: showTooltip.x,
        top: showTooltip.y,
        pointerEvents: 'none',
        transition: 'opacity 0.3s ease'
      }}
    >
      {showTooltip.text}
      <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45"></div>
    </div>
  );
}